import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import gql from "graphql-tag"
import styled from "@emotion/styled"
import { useQuery } from "@apollo/client"
import { useParams } from "react-router-dom"
import { LoadingPage } from "../UI"
import { PageSection } from "../Page/Page"
import { MaxWidth } from "../UI/Containers"
//import { prefixImageUrl } from "../utils/imageUrl"
import NewsList from "./NewsList"

const PostMaxWidth = styled(MaxWidth)`
    width: 1200px;
    max-width: 100%;
    img {
        max-width: 100%;
        margin: 1rem 0;
        height: auto !important;
    }
`

const PageContent = props => {
  const post = props.data?.post

  if (!post) {
    return null
  }

  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{post.title}</title>
        <link rel="canonical" href="http://mysite.com/example" />
      </Helmet>
      <PageSection>
        <PostMaxWidth>
          <h1>{post.title}</h1>
        </PostMaxWidth>
        <PostMaxWidth
          dangerouslySetInnerHTML={{
            __html: post.content
          }}
        />
        {/* <PostMaxWidth>
          {post.image.url && (
            <img src={prefixImageUrl(post.image.url)} alt={post.title} />
          )}
        </PostMaxWidth> */}
      </PageSection>
      <PageSection>
        <NewsList first={8} displayMode='slider' title="Fler nyheter" excludeCurrent={post.title}/>
      </PageSection>
    </Fragment>
  )
}

const NewsPost = () => {
  const { slug } = useParams()

  const { loading, error, data } = useQuery(query, {
    variables: { slug },
  })

  if (loading) return <LoadingPage />
  if (error) {
    console.error("Error fetching post:", error)
    return <p>Error loading post.</p>
  }

  return <PageContent data={data} />
}

const query = gql`
    query Post($slug: String) {
        post(slug: $slug) {
            title
            content
            time {
                created
                timestamp
            }
            image(version: "large") {
                url
            }
        }
    }
`

export default NewsPost
